<template>
  <div class="post type-post hentry">
    <h2>
      <router-link
        to="/2011/01/krikscioniu-partija-%e2%80%9ekasos-aparatai-turguose-%e2%80%93-nesavalaikis-siulymas%e2%80%9c/"
        >Krikščionių partija: „Kasos aparatai turguose – nesavalaikis
        siūlymas“</router-link
      >
    </h2>
    <div class="comm_date">
      <span class="month">Sausio</span><span class="date_nr">23</span>
    </div>
    <div class="comm_date">
      <span class="month">Sausio</span><span class="date_nr">26</span>
    </div>
    <div class="entry">
      <p>
        Krikščionių partijos frakcijos Seime nariai šiandien susitiko su
        Lietuvos smulkiųjų verslininkų ir prekybininkų asociacijos nariais.
        Susitikimo metu aptartos opiausios smulkiesiems verslininkams ir
        prekybininkams problemos bei jų sprendimo būdai. „Vyriausybės siūlymai
        turgavietėse įvesti kasos aparatus taps paskutiniu vinimi į Lietuvos
        smulkaus verslo karstą. Argumentai, kad taip bus išlupti pinigai iš
        šešėlio yra niekiniai, nes ir taip sugriežtintose turgaviečių taisyklėse
        yra numatyta triguba apskaita.
      </p>
      <p>
        Didesnės kontrolės nebus, o patys smulkiausi, vos besiverčiantys
        verslininkai, turės trauktis į pogrindį“, – teigia Lietuvos smulkiųjų
        verslininkų ir prekybininkų asociacijos pirmininkė Zita Sorokienė.
        „Kiekvieną mėnesį verslininkai susimoka 100 litų už verslo liudijimą,
        sveikatos įmoka – 72 litai, „Sodrai“ atseikėjama dar 140 litų, o kur dar
        komunaliniai mokesčiai, sandėliavimo išlaidos ir kt. Aparatų priežiūra
        verslininkams per metus kainuos mažiausiai dar 300 litų, taigi
        smulkiesiems verslininkams taps per didelė prabanga prekiauti turguose“,
        – Z. Sorokienei antrino Lietuvos smulkiųjų verslininkų ir prekybininkų
        asociacijos garbės pirmininkas Eduardas Šablinskas.
      </p>
      <p>
        Anot susitikimo dalyvių kasos aparatų įdiegimas paveiktų mažiausiai 5
        tūkst. smulkiųjų verslininkų, atsižvelgus, į tai, kad jiems padeda
        šeimos nariai, toks Vyriausybės sprendimas pakenktų mažiausiai 15 tūkst.
        žmonių. „Lietuvą ir taip spaudžiant bedarbystei, toks Andriaus Kubiliaus
        Vyriausybės siūlymas yra visiškai nesavalaikis, išlaidų didinimas ir
        mokesčių kėlimas Lietuvos ekonomikos neatgaivins, o dar labiau ją
        pagilins“, – teigia Krikščionių partijos frakcijos Seime seniūnas
        Vidmantas Žiemelis.
      </p>

      <p>
        Susitikimo metu buvo nutarta sudaryti darbo grupę, kuri pateiks
        konkrečius pasiūlymus Vyriausybei, kaip palengvinti smulkiųjų
        verslininkų padėtį.
      </p>
      <p>
        Krikščionių partijos spaudos tarnyba
      </p>
    </div>
  </div>
</template>
